export default "__VITE_ASSET__CQIoACQ1__"